import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { PRICING_FAQS } from '../../constants';

@Component({
  selector: 'app-pricing-faq-section',
  imports: [FaqAccordionComponent, SectionHeaderComponent],
  templateUrl: './pricing-faq-section.component.html',
  styleUrl: './pricing-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = PRICING_FAQS;
}
